export const environment = {
  production: false,
  apiUrl: localStorage.getItem('API_URL') || 'https://staging-api.hubnari.com.br',
  googleClientId: '1006283448865-5gvn0opnncou1uub0qo01g974s9v4iea.apps.googleusercontent.com',
  posthogKey: 'phc_tdagP2682AbzGCagjD6Psefyz2YFAefo5rPxuuoa2Gd8',
  posthogHost: 'https://us.i.posthog.com',
};
